export default __webpack_public_path__ + "static/media/insta.645a1900.svg";